export class CIDPrintPlugin {
}
//# sourceMappingURL=definitions.js.map